module.exports = __webpack_public_path__ + "static/bboxMiami-c8b8d03594d10f3fadb153500bd7d8bc.png";